import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import safety_gen_2_auto_recovery from '@devices/settings/device_settings/safety_gen_2_auto_recovery.js';
import app_setting_pm_gen_2 from '@devices/settings/device_settings/app_setting_pm_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2 from '@devices/settings/device_settings/settings_gen_2.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyPlus2L',
	friendly_name: 'Plus 2L',
	family: 'relay',
	isPM: true,
	reset_from_input: true,
	modes: {
		relay: {
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				safety_gen_2_auto_recovery,
				app_setting_pm_gen_2,
				share,
				settings_gen_2,
			],
		},
	},
};
